module.exports = __webpack_public_path__ + "img/medical_zhoushan.11b6a47b.png";